import { render, staticRenderFns } from "./select.renderer.vue?vue&type=template&id=4054d742&"
import script from "./select.renderer.vue?vue&type=script&lang=js&"
export * from "./select.renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports